import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleButton from "react-google-button";

import useAuth from "../../hooks/useAuth";
import bg from "../../assets/images/social-login-bg.jpeg";

const useStyles = makeStyles((theme) => ({
  loginContainer: {
    backgroundColor: `${theme.palette.background.secondaryLight} !important`,
    padding: theme.spacing(3),
    border: "0 !important",
    borderRadius: 20,
  },
}));

const LoginView = () => {
  const classes = useStyles();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => loginSuccessHandler(codeResponse),
    onError: (errorResponse) => loginFailureError(errorResponse),
    flow: "auth-code",
  });

  const loginSuccessHandler = async (response: any) => {
    await login(response.code);
    const redirectUrl = searchParams.get("redirectUrl") ?? "/";
    navigate(redirectUrl);
  };

  const loginFailureError = (response: any) => {
    console.log("Error while trying to login with google", response);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box textAlign="center">
        <Box className={classes.loginContainer} textAlign="center" mb={4}>
          <Typography variant="h3" color="primaryHighlight.main" mb={3}>
            Sign in
          </Typography>
          <Typography variant="h3" color="primary" mb={3}>
            Welcome back! Please log-in to your account to access Dopple Studio
          </Typography>
          <Box display="flex" justifyContent="center">
            <GoogleButton onClick={() => googleLogin()} />
          </Box>
        </Box>
        <Box>
          <img src={bg} alt="bg" />
        </Box>
      </Box>
    </Box>
  );
};

export default LoginView;
